export const YOUTUBE_VIDEO_BASE_URL = "https://www.youtube.com/watch?v=";
export const SHARE_TO_PERCENT_CONVERSION = 10000;
export const PRICE_FACTOR = 1000000;
export const IS_SERVER = typeof window === "undefined";
export const MOBILE_BREAKPOINT = 600;
export const THUMBNAIL_SIZE = { HEIGHT: 162, WIDTH: 288 };
export const MAX_CONTENT_WIDTH = 1256;
export const CHART_MONTHS_RANGE = 6;
export const CHART_DAYS_RANGE = 30;
export const ASSETS_PER_PAGE = 12;
export const DEFAULT_LOCALE = "en";
export const AVATAR_SIZE = {
    HEIGHT: 144,
    WIDTH: 144,
};
export const DEFAULT_LOADING_STATE_DELAY_MS = 300;
export const MAX_NUM_TOKENS_PER_ASSET = 1000000;
export const MAX_FLOAT_ETH = 5;
export const DEBUG_UNLOCK_AUTHENTICATED_ROUTES = process.env.NEXT_PUBLIC_DEBUG_UNLOCK_AUTHENTICATED_ROUTES === "true";
export const RECEIPT_PREFIX = "943";
// if (process.env.NEXT_PUBLIC_BLOCKCHAIN_NETWORK === undefined) {
//     throw new Error(".env file is most likely missing");
// }
